import { createSelector } from "@reduxjs/toolkit";

export const selectCompanyJobState = (state: any) => state.companyJob;

export const allOptionsLoadedSelector = createSelector(
    [selectCompanyJobState],
    (companyJob) => {
        const { optionsMaster, optionsProfesstion, optionsIndustry } = companyJob;

        const getOptionList = (name: string) =>
        optionsMaster
            ?.filter((option: any) => option.name === name)
            ?.flatMap((option: any) => option.option_list ?? []) ?? [];

        const recruitmentStatus = getOptionList("job_status");
        const employmentStatus = getOptionList("job_type");
        const roleOptions = getOptionList("job_role");
        const workingStyles = getOptionList("job_working_style");
        const payTypes = getOptionList("job_salary_payment_method");
        const prefectures = getOptionList("japan_city");
        const voidSmokingPolicy = getOptionList("job_void_smoking_policy");
        const daysOffPattern = getOptionList("job_days_off_pattern");
        const tagLogicTypes = getOptionList("tag_logic_type");
        
        return (
            recruitmentStatus.length > 0 &&
            employmentStatus.length > 0 &&
            roleOptions.length > 0 &&
            workingStyles.length > 0 &&
            payTypes.length > 0 &&
            prefectures.length > 0 &&
            voidSmokingPolicy.length > 0 &&
            daysOffPattern.length > 0 &&
            tagLogicTypes.length > 0 &&
            optionsProfesstion?.length > 0 &&
            optionsIndustry?.length > 0
        );
    }
);
